import { SVGProps } from "react";

const WalletBanknoteSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle
      cx={7.5}
      cy={17}
      r={1.5}
      stroke="#A3A2A2"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x={2}
      y={13}
      width={11}
      height={8}
      rx={2}
      stroke="#A3A2A2"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 9.5V6.5C21 5.11929 19.8807 4 18.5 4H5.5C4.11929 4 3 5.11929 3 6.5V10"
      stroke="#A3A2A2"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 14.5V17.5C21 18.8807 19.8807 20 18.5 20H16"
      stroke="#A3A2A2"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 9.5H21C21.5523 9.5 22 9.94772 22 10.5V13.5C22 14.0523 21.5523 14.5 21 14.5H19C17.6193 14.5 16.5 13.3807 16.5 12V12C16.5 10.6193 17.6193 9.5 19 9.5V9.5Z"
      stroke="#A3A2A2"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WalletBanknoteSvg;
